import React, { useEffect, useState } from 'react';
import {
   Accordion, AccordionBody, AccordionHeader, AccordionItem, Button,
   Col, FormGroup, Input, Label, Row, Table
} from 'reactstrap';
import { toast } from "react-toastify";
import _ from 'lodash';
import { ItemTypeahead, ServiceThreadSpinner } from '.';
import { DesktopContainer } from '../layouts';
import { api } from '../utils';

const SITE_OPTIONS = {
   All: 0,
   Plant: 1,
   Warehouse: 2,
};

export default function ItemBomLookup() {
   const defaultSelect = { label: "--- Select ---", value: "NA" };
   const [data, setData] = useState(null);
   const [expanded, setExpanded] = useState("0");
   const [item, setItem] = useState(defaultSelect);
   const [loaded, setLoaded] = useState(true);
   const [site, setSite] = useState("PLT");
   const [siteDisplay, setSiteDisplay] = useState("PLT");
   const [siteOpt, setSiteOpt] = useState(1);
   const sleep = ms => new Promise(r => setTimeout(r, ms));

   useEffect(() => {
      inputFocus("itemInput");
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   useEffect(() => {
      if (!loaded) {
         if (!item || item.value === "" || item.value === "NA") {
            toast.warning("You must provide an item");
            setLoaded(true);
            inputFocus("itemInput");
            return;
         }

         // escape the forward slash character or pound symbol if in the item so it won't mess up the URL
         // Example = MP.11/64S40007 this causes the url to look like it has an extra parameter because
         // of the / character so the URL is broken and a Not Found error is thrown.
         var encodedItem = item.value.replace(/\//g, '%2F').replace(/#/g, '%23');
         api
            .post(`Mobile/LookupItemBom/${encodedItem}/${site}`)
            .then(response => {
               if (response.data.success) {
                  setSiteDisplay(site);
                  setData(response.data.item);
               }
               else {
                  setData(null);
                  toast.error(response.data.message);
               }
            })
            .catch((error) => {
               api.catchHandler(error);
               setData(null);
            })
            .finally(() => {
               setLoaded(true);
               inputFocus("itemInput");
            })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [loaded])

   const handleSiteChange = (event) => {
      const value = parseInt(event.target.value);
      if (value === 1)
         setSite("PLT");
      else if (value === 2)
         setSite("PLTWHSE");
      else
         setSite("Total");

      setSiteOpt(value);
      inputFocus("itemInput");
   };

   const handleItemKeypress = e => {
      inputFocus("itemInput");
   };

   async function inputFocus(fieldname) {
      await sleep(80);  // allows time for input to be recognized
      const el = document.querySelector(`input[name=${fieldname}]`);
      if (el !== null) {
         await el.focus();
      }
   }

   const toggle = (idx) => {
      if (expanded === idx) {
         setExpanded("0");
      } else {
         setExpanded(idx);
      }
   };

   return (
      <>
         <DesktopContainer screenName="Item BOM Lookup">
            <ServiceThreadSpinner on={!loaded}>
               <div>
                  <Row className="mb-3">
                     <legend className="col-form-label col-sm-2 h6 mx-2 my-0 fw-bold">
                        Qty Site:
                     </legend>
                     <Col sm="10">
                        <FormGroup check inline>
                           <Label check>
                              <Input
                                 type="radio"
                                 name="siteOption"
                                 value={SITE_OPTIONS.All}
                                 checked={siteOpt === SITE_OPTIONS.All}
                                 onChange={handleSiteChange}
                              />{" "}ALL
                           </Label>
                        </FormGroup>
                        <FormGroup check inline>
                           <Label check>
                              <Input
                                 type="radio"
                                 name="siteOption"
                                 value={SITE_OPTIONS.Plant}
                                 checked={siteOpt === SITE_OPTIONS.Plant}
                                 onChange={handleSiteChange}
                              />{" "}PLT
                           </Label>
                        </FormGroup>
                        <FormGroup check inline>
                           <Label check>
                              <Input
                                 type="radio"
                                 name="siteOption"
                                 value={SITE_OPTIONS.Warehouse}
                                 checked={siteOpt === SITE_OPTIONS.Warehouse}
                                 onChange={handleSiteChange}
                              />{" "}PLTWHSE
                           </Label>
                        </FormGroup>
                     </Col>
                  </Row>
                  <Row className="justify-content-center">
                     <Col xs="12">
                        <ItemTypeahead
                           name="itemInput"
                           value={item ?? defaultSelect}
                           onChange={setItem}
                           onKeyPress={handleItemKeypress}
                        />
                     </Col>
                  </Row>
                  <Row>
                     <Col xs="12">
                        <Button
                           title="item search"
                           className="shredButton w-100 btn-md my-1"
                           onClick={() => setLoaded(false)}>
                           Search
                        </Button>
                     </Col>
                  </Row>
               </div>
               <br />

               {loaded && data ?
                  <div>
                     <Table striped className="data-table mobileGrayBgAlt">
                        <tbody>
                           <tr>
                              <td className="data-cell my-0 py-0">
                                 <label className="text-black h6 mx-2 my-0 fw-bold">{data.itemWithDesc}</label>
                              </td>
                           </tr>
                           <tr>
                              <td className="data-cell my-0 py-0">
                                 <label className="text-black h6 mx-2 my-0">{siteDisplay} On Hand: {Math.round(data.onHand).toLocaleString()}</label>
                              </td>
                           </tr>
                           <tr>
                              <td className="data-cell my-0 py-0">
                                 <label className="text-black h6 mx-2 my-0">Setups: {data.setups}</label>
                              </td>
                           </tr>
                        </tbody>
                     </Table>

                     {data.components ?
                        <div className="filter-header">
                           {data.components.length > 0
                              ? <Accordion open={expanded} toggle={toggle}>
                                 {_.map(data.components, (item, index) => {
                                    return (
                                       <div details={item} key={index} >
                                          <AccordionItem className="mobileBlueBgAlt text-white my-0 py-1 px-1">
                                             <AccordionHeader targetId={String(index)}>
                                                <div>
                                                   {item.itemWithDesc}<br />
                                                   {siteDisplay} On Hand: {Math.round(item.onHand).toLocaleString()}
                                                </div>
                                             </AccordionHeader>
                                             <AccordionBody accordionId={String(index)} className="py-1 px-0">
                                                <div>
                                                   Setups:<br />{item.setups}
                                                </div>
                                             </AccordionBody>
                                          </AccordionItem>
                                       </div>
                                    )
                                 })}
                              </Accordion>

                              : <Row className="justify-content-center">
                                 <Col className=" mobileGrayBg my-0 py-2 px-2 text-white h5" xs="10">No Components Available</Col>
                              </Row>
                           }
                        </div>
                        : null
                     }

                  </div>
                  : null
               }

            </ServiceThreadSpinner>
         </DesktopContainer >
      </>
   );
}
